// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DWEBAPP — global app shell styles */
.App {
  min-height: 100vh;
}

/* Prevent layout shift */
html {
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB","sourcesContent":["/* DWEBAPP — global app shell styles */\n.App {\n  min-height: 100vh;\n}\n\n/* Prevent layout shift */\nhtml {\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
